import CryptoJS from 'crypto-js';

// Fallback secret key if environment variable is not set
const SECRET_KEY = process.env.REACT_APP_TOKEN_ENCRYPT_KEY || 'a6d36c7f9478b4b169778a410d7a2287e0969f1a73b0e0b62552c28915b14aa5';

export const Encrypt = (plainData) => {
  return CryptoJS.AES.encrypt(
    plainData,
    SECRET_KEY,
  ).toString();
};

export const Decrypt = (encrypted) => {
  return JSON.parse(
    CryptoJS.AES.decrypt(encrypted, SECRET_KEY).toString(),
  );
};

// Hash function for passwords - deterministic (same input = same output)
export const HashPassword = (password) => {
  console.log('Encryption Key Available:', !!process.env.REACT_APP_TOKEN_ENCRYPT_KEY);
  const hashedPassword = CryptoJS.HmacSHA256(password, SECRET_KEY).toString();
  console.log('Hashed Password:', hashedPassword);
  return hashedPassword;
};

const toBase64Url = (base64Text) =>
  String(base64Text)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/g, '');

const fromBase64Url = (base64UrlText) => {
  const normalized = String(base64UrlText)
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  const paddingLength = (4 - (normalized.length % 4)) % 4;
  return normalized + '='.repeat(paddingLength);
};

const buildDecryptCandidates = (cipherToken) => {
  const raw = String(cipherToken || '').trim();
  if (!raw) return [];

  const decoded = (() => {
    try {
      return decodeURIComponent(raw);
    } catch (error) {
      return raw;
    }
  })();

  const candidates = [
    decoded,
    fromBase64Url(decoded),
  ];

  return candidates.filter((value, index, list) => value && list.indexOf(value) === index);
};

export const encryptRouteParam = (plainText) => {
  if (plainText === undefined || plainText === null) return '';
  try {
    const encrypted = CryptoJS.AES.encrypt(String(plainText), SECRET_KEY).toString();
    return toBase64Url(encrypted);
  } catch (error) {
    return '';
  }
};

export const decryptRouteParam = (encodedCipherText) => {
  if (!encodedCipherText) return '';
  const candidates = buildDecryptCandidates(encodedCipherText);

  for (const candidate of candidates) {
    try {
      const bytes = CryptoJS.AES.decrypt(candidate, SECRET_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      if (decrypted) return decrypted;
    } catch (error) {
      // Try next candidate.
    }
  }

  return '';
};
